import { render } from "./Task.vue?vue&type=template&id=22df00ad&scoped=true"
import script from "./Task.vue?vue&type=script&lang=js"
export * from "./Task.vue?vue&type=script&lang=js"

import "./Task.vue?vue&type=style&index=0&id=22df00ad&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-22df00ad"

export default script